import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { FlagIcon, Heart2Icon } from "../assets/icons";
import { CategoryLoadingCard, SectionHeading } from "./ReportCategoryShared";

function getOtherReportData(statistic, period) {
  const materialSummaries = (statistic?.summary_materials || []).filter(
    (item) => item.periode === period,
  );
  const otherMetrics = materialSummaries
    .filter((item) => item.material === "Pencapaian Lainnya")
    .flatMap((item) => item.indicators || [])
    .filter((item) => !String(item.name || "").toLowerCase().includes("pilih nama"))
    .map((item) => ({ label: item.name, value: item.value }));
  const reflections = materialSummaries
    .filter((item) => item.material === "Refleksi Orangtua")
    .flatMap((item) => item.indicators || [])
    .map((item) => {
      const [title, ...descriptionParts] = String(item.name || "").split(":");
      return {
        title,
        description: descriptionParts.join(":").trim(),
        label: item.label,
        tone: Number(item.value) <= 2 ? "missing" : "positive",
      };
    });

  return { otherMetrics, reflections };
}

function ReflectionItem({ item, isLast }) {
  const missing = item.tone === "missing";

  return (
    <View style={[styles.reflectionItem, isLast && styles.lastRow]}>
      <Text style={styles.reflectionTitle}>
        {item.title}: <Text style={styles.reflectionDescription}>{item.description}</Text>
      </Text>
      <View style={[styles.reflectionStatus, missing ? styles.missing : styles.positive]}>
        <FlagIcon width={13} height={13} customColor={missing ? "#D84343" : "#48B920"} />
        <Text style={[styles.statusText, missing && styles.missingText]}>{item.label}</Text>
      </View>
    </View>
  );
}

export default function ReportOtherContent({ statistic, period, loading, loadError }) {
  if (loading || loadError) {
    return (
      <View style={styles.content}>
        <CategoryLoadingCard Icon={Heart2Icon} title="Pencapaian Lainnya" loading={loading} loadError={loadError} />
        <CategoryLoadingCard Icon={Heart2Icon} title="Refleksi Orangtua" loading={loading} loadError={loadError} />
      </View>
    );
  }

  const { otherMetrics, reflections } = getOtherReportData(statistic, period);

  return (
    <View style={styles.content}>
      <View style={styles.card}>
        <SectionHeading Icon={Heart2Icon} title="Pencapaian Lainnya" />
        <View style={styles.divider} />
        {otherMetrics.map((item, index) => (
          <View key={`${item.label}-${index}`} style={[styles.metricRow, index === otherMetrics.length - 1 && styles.lastRow]}>
            <Text style={styles.metricLabel}>{item.label}</Text>
            <Text style={styles.metricValue}>{item.value}</Text>
          </View>
        ))}
        {otherMetrics.length === 0 && <Text style={styles.emptyText}>Belum ada data pencapaian lainnya untuk periode ini.</Text>}
      </View>

      <View style={styles.card}>
        <SectionHeading Icon={Heart2Icon} title="Refleksi Orangtua" />
        <View style={styles.divider} />
        {reflections.map((item, index) => (
          <ReflectionItem key={`${item.title}-${index}`} item={item} isLast={index === reflections.length - 1} />
        ))}
        {reflections.length === 0 && <Text style={styles.emptyText}>Belum ada refleksi orangtua untuk periode ini.</Text>}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  content: { gap: 16 },
  card: { padding: 14, borderRadius: 14, backgroundColor: "#FFFFFF", elevation: 2, shadowColor: "#34234A", shadowOpacity: 0.08, shadowRadius: 5, shadowOffset: { width: 0, height: 2 } },
  divider: { height: 1, marginTop: 10, marginBottom: 5, backgroundColor: "#EEEEEE" },
  metricRow: { minHeight: 39, flexDirection: "row", alignItems: "center", justifyContent: "space-between", borderBottomWidth: StyleSheet.hairlineWidth, borderBottomColor: "#EEEEEE", borderStyle: "dashed" },
  metricLabel: { color: "#6724E2", fontFamily: "Archivo-Regular", fontSize: 10 },
  metricValue: { color: "#48B920", fontFamily: "Archivo-Bold", fontSize: 10 },
  reflectionItem: { paddingVertical: 9, borderBottomWidth: StyleSheet.hairlineWidth, borderBottomColor: "#EEEEEE", borderStyle: "dashed" },
  lastRow: { borderBottomWidth: 0 },
  reflectionTitle: { color: "#181818", fontFamily: "Archivo-Bold", fontSize: 10, lineHeight: 15 },
  reflectionDescription: { fontFamily: "Archivo-Regular" },
  reflectionStatus: { minHeight: 22, alignSelf: "flex-start", marginTop: 6, paddingHorizontal: 7, borderRadius: 5, flexDirection: "row", alignItems: "center", gap: 4 },
  positive: { backgroundColor: "#DDF3D5" },
  missing: { backgroundColor: "#FFE0E0" },
  statusText: { color: "#48B920", fontFamily: "Archivo-Regular", fontSize: 9 },
  missingText: { color: "#D84343" },
  emptyText: { paddingVertical: 12, color: "#777777", fontFamily: "Archivo-Regular", fontSize: 11, textAlign: "center" },
});
